module.exports = "/templates/customeradd.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/customeradd.html
// module id = 442
// module chunks = 0